<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
    <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
        <mat-card-title>
            <div class="w-100 d-flex" style="background: #e5edff;height: 80px;">
                <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">{{title | translate}}</span>
            </div>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content style="flex: 1;padding: 0;">
        <p style="padding: 20px; font-size: 16px; line-height: 2rem;">{{ message | translate }}</p>
        <ng-container *ngIf="confirmText">
            <div style="padding: 20px; background: #f3d7d7; border: 2px solid #bd2929; margin: 20px; border-radius: 6px;">
                <p style="padding: 0;">{{ "Pour confirmer, veuillez saisir " | translate }} <span style="color: #bd2929;font-weight: 600;">"{{ confirmText | translate }}"</span> {{ "dans la zone de texte" | translate }}</p>
                <mat-form-field class="w-100">
                    <mat-icon matSuffix style="color: #1d1e20; background: #d0d4de; border-radius: 5px; margin-right: 4px;">check_circle_outline</mat-icon>
                    <input matInput [autocomplete]="'off'" placeholder="{{ 'Saisir votre message de confirmation..' | translate }}" class="cplaceholder" [(ngModel)]="confirmTextInput">
                </mat-form-field>
            </div>
        </ng-container>
    </mat-card-content>
    <mat-card-actions class="d-block m-0 p-0" style="background-color: #0f172a;border-top: 3px solid #5d87ff;">
        <div class="d-flex w-100" style="border-right: 3px solid #1855d5; margin-right: 15px;height: 100px;">
            <button mat-stroked-button style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; margin-top: auto; margin-bottom: auto; height: 80px;" (click)="onDismiss();">
                {{ "NON" | translate }}
            </button>
            <button mat-stroked-button (click)="onConfirm();" [disabled]="confirmText && confirmTextInput != confirmText" class="ccmainfo" style="color: #1bbaee; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; margin-top: auto; margin-bottom: auto; height: 80px;">
                {{ "OUI" | translate }}
            </button>
        </div>
    </mat-card-actions>
</mat-card>